import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map, Observable } from 'rxjs';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';

function labelsEqual(a: any, b: any): boolean {
    if (!a || !b) return false;
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        return a.every(labelA => b.some(labelB => labelA.key === labelB.key && labelA.value === labelB.value));
    } else if (typeof a === 'object' && typeof b === 'object') {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        return aKeys.every(key => a[key] === b[key]);
    }
    return false;
}

@Injectable({
    providedIn: 'root',
})
export class AlertService {
    constructor(private firestore: AngularFirestore) {

    }

    getAllAlerts(limit: number): Observable<any[]> {
        return this.firestore.collection('alerts', ref => ref.limit(limit).orderBy('startsAt', 'desc')).snapshotChanges().pipe(map(actions =>
            actions.map(a => {
                const data = a.payload.doc.data() as any;
                const id = a.payload.doc.id;
                return { id, ...data };
            })
        ));
    }

    getAlertsBySystemId(systemId: string): Observable<any[]> {
        return this.firestore.collection('alerts', ref => ref.where('systemId', '==', systemId).orderBy('startsAt', 'desc')).snapshotChanges().pipe(map(actions =>
            actions.map(a => {
                const data = a.payload.doc.data() as any;
                const id = a.payload.doc.id;
                return { id, ...data};
            })
        ));
    }

    deleteAlert(alertId: string): Promise<void> {
        return this.firestore.collection('alerts').doc(alertId).delete();
    }

}